import { roomActionSelectors as selector } from "../Selectors/index";

export const roomReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET:
      return payload;

    default:
      return state;
  }
};


